import { createApp } from 'vue'
import Contact from './register.vue'
import i18n from "../locales";

createApp(Contact)
  .use(i18n())
  .mount('#register')
